import AuthService from './AuthService';

const ModulesService = {
  async getStudentModules(endPoint) {
    const MODULES_ENDPOINT = endPoint + '/v3/student/modules/';
    try {
      const { url, headers } = await AuthService.getSignedRequest(
        MODULES_ENDPOINT
      );
      const response = await fetch(url, { headers });
      return await response.json();
    } catch (e) {
      console.error(e);
      return [];
    }
  },

  getModuleConfig({
    order,
    currentModule,
    previousModule,
    totalDays,
    bgImage,
    destiny,
    character,
    title,
    welcomeVideo,
    login,
  }) {
    const IMAGES_ENDPOINT = login.cloudFront + 'images';
    const config = {};
    let image = '';

    switch (character) {
      case 'Bird':
        image = '/Images/Button_BirdHead.png';
        break;
      case 'Crab':
        image = '/Images/Button_CrabHead.png';
        break;
      case 'Dog':
        image = '/Images/Button_DogHead.png';
        break;
      case 'Lizard':
        image = '/Images/Button_Lizardhead.png';
        break;
      case 'Monkey':
        image = '/Images/Button_monkeyHead.png';
        break;
      default:
        break;
    }

    const previousModuleCompleted = !previousModule
      ? true
      : previousModule.day_completed === totalDays;

    config.moduleID = currentModule.id;
    config.background = `${IMAGES_ENDPOINT}${bgImage}${login.cookie}`;
    config.bouncing =
      previousModuleCompleted && currentModule.day_completed < totalDays;
    config.className = `unit__module unit--${character.toLowerCase()}`;
    config.destiny = destiny;
    config.image = `${IMAGES_ENDPOINT}${image}${login.cookie}`;
    config.title = title;
    config.welcomeVideo = welcomeVideo;
    config.daysCompleted = currentModule.day_completed;
    config.notStarted =
      currentModule.day_completed === 0 &&
      currentModule.stepCompleted === 'notstarted';
    config.complete = currentModule.day_completed === totalDays;
    config.inProgress =
      currentModule.day_completed > 0 &&
      currentModule.day_completed < totalDays;
    config.previousModuleCompleted = previousModuleCompleted;
    config.previousModuleDayCompleted = !previousModule ? 0 : previousModule.day_completed
    config.totalDays = totalDays;
    config.order = order;

    return config;
  },
};

export default ModulesService;
